import { Input, Table } from 'antd';
import utils from '../../../Functions/utils';
import HeaderComp from '../../Header/Header';
import './BOMain.css';
import { useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';

import Swal from 'sweetalert2';

function BOMainComp() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuHeaderOpen, setMenuHeaderOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [userData, setuserData] = useState({});
  const [error, setError] = useState('');
  const [lizchus, setLizchus] = useState('');
  const [editLizchus, setEditLizchus] = useState('');
  const [isEditLizchus, setIsEditLizchus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    

    const fetchData = async () => {
      await fetchUsers();
    };
    fetchData();
  }, []);

    
  const fetchUsers = async () => {
    try {
      const resp = await utils.requestData('BOGetUsers');
      setUsers(resp);
    } catch (err) {
      console.error('Error fetching BOUsers:', err);
      setError(err.message);
    }
  };

  const updateLizchus = async () => {
    try {      
      const localKey = 'lizchus';
      await utils.requestData('UpdateLizchus', {lizchus : editLizchus});
      setLizchus(localStorage.getItem(localKey))
      localStorage.setItem(localKey, editLizchus);
      setEditLizchus('')
      await Swal.fire({
        title: 'עדכון הקדשה',
        html: `<div>עודכן בהצלחה</div>`,
        icon: 'success',
      });
    } catch (err) {
      console.error('Error donate:', err);
      setError(err.message);
      Swal.fire('שגיאה', err.message, 'error');
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };


  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text) => <span>{text}</span>,
      width: 100,
    },
    {
      title: "שם",
      dataIndex: "name",
      key: "name",
      render: (name) => <span>{name}</span>,
      width: 200,
    },
  ];


  return (
    <div className="tanya-container">
      <HeaderComp
        userData={userData}
        menuHeaderOpen={menuHeaderOpen}
        setMenuHeaderOpen={setMenuHeaderOpen}
      />


      <div style={{ marginBottom: 16, marginTop: 16 }}>
        <Input
          placeholder="חיפוש לפי שם או ID"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={handleSearch}
          style={{ width: 250 }}          
        />
      </div>

      <Table
        columns={columns}
        dataSource={users.length > 0 && users.filter((user) =>
                    user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
                    user.id?.toString().includes(searchText)
        )}
        rowKey="id"
        loading={loading}
        bordered
        pagination={{ pageSize: 100 }}
        scroll={{ y: 500 }} // הגדרת גובה פנימי לגלילה
      />

      <div>
        <h4 className="dedication-box" onClick={() => setIsEditLizchus(!isEditLizchus)}>
          {localStorage.getItem('lizchus')}
        </h4>
        
          {
            isEditLizchus && 
            <div>
              <input type="text" onChange={(e) => setEditLizchus(e.target.value)} />
              
              <button onClick={() => updateLizchus()}>
                Save
              </button>
            </div>
          }
      </div>
    </div>
  );
}

export default BOMainComp;
